var map = {
	"./bookmarks.jpg": "0427",
	"./maze.jpg": "ed69",
	"./notes.jpg": "878d",
	"./reel.jpg": "ee93",
	"./time.jpg": "e101",
	"./website.jpg": "c01b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0ac6";